import updateTree from './updateTree'

export default function scorecardSummary(state = {}, action) {
  switch (action.type) {
    case 'SET_SCORECARD_SUMMARY':
      return updateTree(state, 'scorecardSummary', () => action.scorecardSummary)

    default:
      return {
        ...state,
        scorecardSummary: Array.isArray(state.scorecardSummary) ? state.scorecardSummary : [],
      }
  }
}
